import $ from 'jquery';

export default {
  jsClass: 'js-postal-code',
  ajaxInitialized: false,
  ajaxUrl: null,
  subscribers: [],
  dom: {
    $field: null
  },
  enableAjax() {
    const self = this;

    this.dom.$field = $('.' + this.jsClass);

    if(!this.dom.$field.length) {
      return;
    }

    this.ajaxUrl = this.dom.$field.data('url');
    const pattern = this.dom.$field.attr('pattern');
    const regEx = new RegExp(pattern);

    this.dom.$field.on('keyup', function() {
      const $this = $(this);
      const value = $this.val();

      // If valid postal code, search for post office
      if(regEx.test(value)) {
        $.get(self.ajaxUrl + '&postal_code=' + $this.val(), function(data) {
          self.notifySubscribers('fetchOffice', data);
        });
      }
    });
  },
  /**
   * Subscribe to postal code events
   * @param {string} eventType 'fetchOffice' only at the moment
   * @param {Function} callback callback function
   */
  on(eventType, callback) {
    if (!this.ajaxInitialized) {
      this.enableAjax();
    }
    this.subscribers.push({
      eventType: eventType,
      callback: callback
    });
  },
  notifySubscribers() {
    const args = Array.prototype.slice.call(arguments);
    const eventType = args[0];

    // Remove eventType from arguments
    args.shift();

    for (let i = 0, l = this.subscribers.length; i < l; i++) {
      if (this.subscribers[i].eventType === eventType) {
        this.subscribers[i].callback.apply(this, args);
      }
    }
  }
}
